module.exports = __webpack_public_path__ + "media/images/application2/AppSettingsUsersSettingList__a-76ec0609c98db9f0000bbee2ba516829.svg";